import {scrollPageFromCookie} from "../../../utils/scrollPageFromCookie";

export const initFeed = () => {
	const components = document.querySelectorAll( 'section.feed:not(.carousel)' );

	if ( components.length ) {

		components.forEach( ( component ) => {

			component.querySelectorAll( 'ul.cards > li' ).forEach( ( elem ) => {
				elem.addEventListener( 'click', () => {
					document.cookie = `scroll=${window.scrollY}`;
				} )
			});

			scrollPageFromCookie();
		});
	}
}